import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Flex } from "antd";
import { LoaderBox } from "src/components/LoaderBox";
import { ZUid } from "src/types/zUid";
import { schedulingControlStore as store } from "./SchedulingControlStore";
import styles from "./SchedulingControl.module.less";
import { SchedulingTable } from "./SchedulingTable";
import { StartDatePicker } from "./StartDatePicker";

interface PropsSchedulingControl {
  entityId: ZUid;
  objectServiceId: ZUid;
}

export const SchedulingControl: React.FC<PropsSchedulingControl> = observer(
  ({ entityId, objectServiceId }) => {
    useEffect(() => {
      store.init(entityId, objectServiceId);
    }, [entityId, objectServiceId]);
    return (
      <>
        <div className={styles.title}>
          {store.projectInfo?.name?.value ?? ""}
        </div>
        <div className={styles.box}>
          <Flex vertical gap={16} className={styles.content}>
            <StartDatePicker store={store} />
            <LoaderBox
              remoteData={store.data}
              drawReady={() => <SchedulingTable store={store} />}
            />
          </Flex>
        </div>
      </>
    );
  },
);
